module.exports = __webpack_public_path__ + "beb2eea6.svg";